import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconThumbsUp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M12.445 5.625H8.41375V1.875C8.45338 1.61971 8.43222 1.35867 8.35201 1.11309C8.2718 0.867511 8.13479 0.644317 7.95211 0.461638C7.76943 0.278959 7.54624 0.141948 7.30066 0.0617351C7.05508 -0.0184775 6.79404 -0.0396296 6.53875 -2.68035e-06C6.40761 0.00904874 6.28266 0.0592201 6.18167 0.143376C6.08068 0.227531 6.0088 0.341386 5.97625 0.468747L3.75 7.5V15H11.7887C12.3849 14.9885 12.9575 14.7652 13.404 14.3701C13.8506 13.9751 14.1421 13.434 14.2262 12.8437L14.9762 8.53125C15.0353 8.18191 15.0154 7.8238 14.9181 7.48314C14.8207 7.14249 14.6484 6.82792 14.4137 6.5625C14.1855 6.2591 13.8872 6.0154 13.5444 5.85216C13.2016 5.68892 12.8244 5.61098 12.445 5.625Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M2.5 7.5H0V15H2.5V7.5Z",
			fill: "currentColor"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "white"
		})
	}) })]
});
export default SvgIconThumbsUp;
